export default __webpack_public_path__ + "static/media/add-fee-enabled.e9ae7f41.svg";